import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { LoadingComponent } from "../../helpers/LoadingComponent";
import ImportTableWithMap from "../ImportTable/ImportTableWithMap";
import { loadItemsButton, itemSelector } from "../ImportHelpers";
import PortalTooltip from "../../helpers/PortalTooltip";
import { ImportFormProagricaProps } from "./ImportForm_Proagrica.types";
import { useImportFormProagricaViewModel } from "./ImportForm_Proagrica.vm";
import "./ImportForm_Proagrica.css";

export function ProagricaImportForm(props: ImportFormProagricaProps) {
	const vm = useImportFormProagricaViewModel(props);

	return (
		<>
			<Grid className="proagrica-import-form" container spacing={1}>
				{/* Step 1: Log in if auth isn't available */}
				{vm.canShowLoginButton && (
					<Grid size={12}>
						<PortalTooltip title="Authenticate with your Proagrica/AGX account" placement="top">
							<Button fullWidth disabled={!!vm.loading} variant="contained" color="primary" onClick={vm.login}>
								Proagrica Login
							</Button>
						</PortalTooltip>
					</Grid>
				)}

				{vm.canLoadGrowers && loadItemsButton(!!vm.loading, vm.getGrowers, "Load Growers")}

				{vm.showGrowerSelector &&
					itemSelector(
						!!vm.loading,
						vm.growers,
						vm.selectedGrowers,
						vm.handleGrowerChange,
						vm.setSelectedGrowers,
						(option) => option.ID,
						(option) => option.Name,
						"Choose your grower(s)",
					)}

				{vm.canLoadFields && loadItemsButton(!!vm.loading, vm.getFields, "Load Fields")}

				{vm.showFieldSelector &&
					itemSelector(
						!!vm.loading,
						vm.fields,
						vm.selectedFields,
						(_event, value) => vm.setSelectedFields(value),
						vm.setSelectedFields,
						(field) => field.ID,
						(field) => `${field.GrowerName ? `${field.GrowerName} - ` : ""}${field.Name}`,
						"Choose your field(s)",
					)}

				{vm.canLoadJobs && loadItemsButton(!!vm.loading, vm.getSamplingEvents, "Load Jobs")}

				{vm.showLoadingSpinner && (
					<Box className="loading-spinner-container">
						<LoadingComponent />
					</Box>
				)}
			</Grid>

			{/* Only show ImportTable here when NOT in modal mode - parent handles it in modal mode */}
			{vm.showImportTable && (
				<>
					<ImportTableWithMap
						jobs={vm.jobs}
						updateJobs={() => {}}
						deals={props.selectedDeals}
						allDeals={props.deals}
						setLoading={(task: string | boolean) => {
							// Loading is managed internally by ViewModel
							void task;
						}}
						allOptions={{ Boundary: [], Zones: [], Centroids: [], Cores: [], Unknown: [] }}
						resetForm={vm.resetForm}
						integration="Proagrica"
						user={vm.userContext}
						featureStats={vm.featureStats}
						allowMap={true}
						selectedCompany={props.selectedCompany ?? undefined}
						salespersons={props.salespersons ?? []}
						branches={props.branches ?? []}
						lastCropOptions={props.lastCropOptions}
						nextCropOptions={props.nextCropOptions}
					/>
				</>
			)}
		</>
	);
}
